import { Component, Prop, Listen, Element, Host, h } from '@stencil/core';
import { KEY_CODES } from '../../utils/variables';

/**
 * A card is a flexible and extensible content container. It can include a wide variety of content, contextual background colors, and powerful display options.
 */
@Component({
  tag: 'som-card',
  styleUrl: 'som-card.scss',
  shadow: true
}) 
export class SomCard {
  @Element() el: HTMLElement;

  /**
   * This property will determine the color applied to the card background and border
   */
  @Prop() color: 'white' | 'light-gray' | 'success' | 'warning' | 'danger' | 'info' | 'transparent' = 'white';

  /**
   * This boolean is used to add 100% height to the card which is helpful when you want the card height to expand to match
   * the height of surrounding elements.
   */
  @Prop() matchHeight: boolean = false;
  
  /**
  * The type of card.
  */
  @Prop() type: 'default' | 'button' = 'default';

  /**
  * This property can be used to set the ARIA label associated with this card (for screen readers).
  */
  @Prop() buttonAriaLabel: string;

  @Listen('keyup')
  handleKeyUp(ev){
    switch (ev.keyCode) {
      case KEY_CODES.ENTER:
      case KEY_CODES.SPACE:
        this.el.click();
    }
  }

  getAttrs() {
    let attrs = {};

    if (this.type === 'button') {
      attrs['role'] = 'button';
      attrs['tabindex'] = '0';
      attrs['onKeyUp'] = this.handleKeyUp.bind(this);
      attrs['aria-label'] = this.buttonAriaLabel ? this.buttonAriaLabel : null;
    }

    return attrs;
  }

  render() {
    return (
      <Host 
        class={`card-container card-${this.color}-container d-flex ${this.type === 'button' ? 'card-clickable' : ''} ${this.matchHeight ? 'h-100' : ''}`}
        {...this.getAttrs()}
      >
          <div class={`card card-${this.color}`}>
            <slot />
          </div>
      </Host>
    );
  }
}
